export default {
  invalidContractSeason: 'Season must be current year or later.',
  invalidDateRange: 'Contract cannot end before it starts.',
  invalidName: 'Name must exist and be less than 30 characters long.',
  invalidProductLine: 'Product line must be selected.',
  invalidProducts: 'Product limit reached (10 max).',
  invalidRegion: 'Region must be selected.',
  invalidVolume: 'Volume must be a positive number.',
  productRequired: 'At least one product is required.',
  productLimitExceeded: 'Maximum number (10) of products reached.',
  dealStatusNotSelected: 'Please select a status.',
};
